import type { Webcast, WebcastOrder } from '../../../../../generated/graphql-manager';

import { usePrevious } from '@movingimage-evp/mi-ui-component-library';
import { useEffect } from 'react';

import { WebcastCard } from '../../../../../components/webcast-card';
import { useUiState } from '../../../../providers/ui-state-provider/ui-state-provider';

import styles from './grid.module.css';

export type Props = {
  webcasts: Webcast[] | undefined;
  orderBy?: WebcastOrder;
  isRefetching?: boolean;
  onArchiveWebcast: (id: Webcast['id']) => void;
  onDeleteWebcast: (id: Webcast['id']) => void;
  onDuplicateWebcast: (id: Webcast['id'], name: Webcast['name']) => void;
  onUnarchiveWebcast: (id: Webcast['id']) => void;
  onSort?: (order: WebcastOrder) => void;
};

export function GridView({
  webcasts,
  isRefetching,
  onArchiveWebcast,
  onDeleteWebcast,
  onDuplicateWebcast,
  onUnarchiveWebcast,
}: Props) {
  const { getEventsScrollPosition, saveUiState } = useUiState();
  const wasRefetching = usePrevious(isRefetching);

  useEffect(() => {
    const handleScroll = () => {
      saveUiState({ key: 'eventsScrollPosition', value: Math.round(window.scrollY) });
    };

    window.scrollTo({ top: getEventsScrollPosition(), behavior: 'smooth' });
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [getEventsScrollPosition, saveUiState]);

  useEffect(() => {
    if (wasRefetching && !isRefetching) {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }
  }, [isRefetching, wasRefetching]);

  return (
    <div className={styles.grid}>
      {webcasts?.map((webcast) => {
        const { id, name } = webcast;

        return (
          <WebcastCard
            key={id}
            webcast={webcast}
            onArchive={() => onArchiveWebcast(id)}
            onDelete={() => onDeleteWebcast(id)}
            onDuplicate={() => onDuplicateWebcast(id, name)}
            onUnarchive={() => onUnarchiveWebcast(id)}
          />
        );
      })}
    </div>
  );
}
